<!--
 * @Descripttion: 套餐管理
 * @version: 
 * @Author: alex.yang
 * @Date: 2023-12-19 17:43:10
 * @LastEditors: alex.yang
 * @LastEditTime: 2024-04-29 08:47:22
-->
<template>
    <div class="serviceManagement">
        <div class="sm-title">
            <div class="mt-title">用户反馈</div>
            <!-- <div class="mt-add">
                <div class="add" @click="clickAddBtn">创建套餐</div>
            </div> -->
        </div>
        <div class="sm-content">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column align="center" prop="user.name" label="反馈用户名称"></el-table-column>
                <el-table-column align="center" prop="user.phone" label="反馈用户手机"></el-table-column>
                <el-table-column align="center" prop="user.company_name" label="反馈用户公司"></el-table-column>
                <el-table-column align="center"  label="反馈类型">
                    <template slot-scope="scope">
                        <div class="btn-wrap">
                            <div v-if="scope.row.type == 1">提个建议</div>
                            <div v-if="scope.row.type == 2">功能问题</div>
                            <div v-if="scope.row.type == 3">其他问题</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="content" label="反馈内容"></el-table-column>
                <el-table-column align="center" label="反馈图片">
                    <template slot-scope="scope">
                        <div class="img-wrap">
                            <el-image
                                class="img" v-for="(img,index) in scope.row.img" 
                                :key="index" 
                                :src="img"
                                :preview-src-list="scope.row.img"
                                :initial-index="0"
                                :z-index="9999"
                                fit="cover">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="time" label="反馈时间"></el-table-column>
                
            </el-table>
        </div>
    </div>
</template>

<script>
import api from "@/utils/common.js"
import pageMixin from '@/internal/pageMixin'
export default {
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'userFeebackList',
            tableData: [],
        }
    },
    mounted () {
        this.getFeedbackList()
    },
    methods: {
        // 获取用户反馈
        getFeedbackList(){
            let params = {
                page_num: 1,
                page_size: 200,
            }
            api.post('/service/system/get_user_feedback_list', params, (res) =>  {
                this.tableData = res.data.list
            });
        },
    },
}
</script>

<style lang='scss'>
.serviceManagement{
    .sm-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 20px 40px;
        .mt-title{
            font-size: 24px;
            color: #101010;
        }
        .mt-add{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .add{
                width: 130px;
                height: 36px;
                border-radius: 6px;
                border: 1px solid #0068ff;
                font-size: 14px;
                color: #0068ff;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }
    }
    .sm-content{
        margin: 20px;
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        .code{
            text-align: center;
            width: 150px;
            padding: 5px 20px;
            border: 1px solid #ddd;
            background: #e6effd;
            border-radius: 9px;
        }
        .btn-wrap{
            display: flex;
            justify-content: center;
            align-items: center;
            .btn{
                padding: 0 15px;
                cursor: pointer;
                font-size: 14px;
                color: #0068ff;
            }
        }
        .img-wrap{
            display: flex;
            justify-content: center;
            align-items: center;
            .img{
                width: 50px;
                height: 50px;
                margin-right: 10px;
            }
        }
    }
}
</style>
